import React from 'react'
import config from '../../config'

class HandleCodeComponent extends React.Component {
  componentDidMount () {
    if (this.hasCode()) {
      this.setToken(this.getCode(), this.getState())
    } else {
      let urlString = window.location.href
      let urlArray = urlString.split('/')
      const product = urlArray[4]
      if (product !== '') {
        if (urlArray[urlArray.length - 1] !== 'dashboard-by-vehicle' &&
         urlArray[urlArray.length - 1] !== 'tickets' &&
         urlArray[urlArray.length - 1] !== 'in-progress-tickets' &&
         urlArray[urlArray.length - 1] !== 'tickets-to-ckeck' &&
         urlArray[urlArray.length - 1] !== 'events' &&
         urlArray[urlArray.length - 1] !== 'events-to-check' &&
         urlArray[urlArray.length - 1] !== 'events-by-vehicle' &&
         urlArray[urlArray.length - 1] !== 'events-to-check-by-vehicle' &&
         urlArray[urlArray.length - 1] !== 'tickets-by-vehicle' &&
         urlArray[urlArray.length - 1] !== 'in-progress-tickets-by-vehicle' &&
         urlArray[urlArray.length - 1] !== 'tickets-to-ckeck-by-vehicle') {
          document.location.href = `/#/${product}/dashboard`
        }
      } else document.location.href = config.salt_url
    }
  }

  hasCode () {
    var urlString = window.location.href
    var url = new URL(urlString)
    if (url.searchParams.get('code')) {
      return true
    }
    return false
  }

  getCode () {
    var urlString = window.location.href
    var url = new URL(urlString)
    return url.searchParams.get('code')
  }

  getState () {
    var urlString = window.location.href
    var url = new URL(urlString)
    return url.searchParams.get('state')
  }

  setToken (code, state) {
    let details = {
      grant_type: 'authorization_code',
      code: code,
      client_id: config.clientId,
      redirect_uri: config.redirect_uri
    }

    let formBody = []
    for (let property in details) {
      let encodedKey = encodeURIComponent(property)
      let encodedValue = encodeURIComponent(details[property])
      formBody.push(encodedKey + '=' + encodedValue)
    }
    formBody = formBody.join('&')
    const request = new Request(config.tokenRequest, {
      method: 'POST',
      body: formBody,
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      })
    })
    fetch(request)
      .then(response => response.json())
      .then((token) => {
        localStorage.setItem('token', token.access_token)
        localStorage.setItem('refresh_token', token.refresh_token)
        let clientUrl = localStorage.getItem(state)
        if (clientUrl) {
          let urlArray = clientUrl.split('#')
          if (urlArray[1]) {
            document.location.href = '/#' + urlArray[1]
          } else document.location.href = config.salt_url
        } else document.location.href = config.salt_url
      })
      .catch((error) => {
        console.log('catch error', error)
      })
  }

  render () {
    return null
  }
}

export default HandleCodeComponent
